import { Grid, Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { TextFieldLight } from "../../../common/components/styled/styled";
import { AutocompleteType } from "../../../common/types/autoComplete";
import { OrderFields } from "../orderTypes";

const Input = ({ ...props }) => (
  <TextFieldLight
    {...props}
    sx={{ width: "110px" }}
    name="salaryLimit"
    size="small"
    placeholder="€/h"
    inputProps={{
      style: {
        textAlign: "center",
      },
    }}
  />
);

type Props = {
  values: OrderFields;
  onOrderTemplateChange: (
    name: string,
    value: Date | string | null | AutocompleteType | AutocompleteType[],
  ) => void;
  periodStartDateIsRequired: boolean | null;
  handleError: (error: boolean, errorObject: any) => void;
};
const SalaryLimit = ({
  values,
  onOrderTemplateChange,
  periodStartDateIsRequired,
  handleError,
}: Props) => {
  const { t } = useTranslation("order");

  useEffect(() => {
    if (
      periodStartDateIsRequired === false &&
      values.orderTemplate.periodStartDate
    ) {
      onOrderTemplateChange("periodStartDate", null);
    }
  }, [
    periodStartDateIsRequired,
    onOrderTemplateChange,
    values.orderTemplate.periodStartDate,
  ]);

  return (
    <>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("salaryLimitLabel")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <NumericFormat
          value={values.orderTemplate.salaryLimit}
          decimalSeparator=","
          valueIsNumericString
          onValueChange={(values) =>
            onOrderTemplateChange("salaryLimit", values.value)
          }
          suffix=" €/h"
          customInput={Input}
          decimalScale={2}
        />
      </Grid>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("periodStartDate")}</Typography>
      </Grid>
      <Grid item xs={8}>
        {/* TODO FIXME check if date can be formatted with weekday */}
        <DesktopDatePicker
          format={"dd.MM.yyyy"}
          disabled={periodStartDateIsRequired === false}
          value={values?.orderTemplate?.periodStartDate}
          onChange={(value: any) => {
            onOrderTemplateChange("periodStartDate", value);
          }}
          onError={(reason) =>
            handleError(!!reason, {
              id: values.id,
              field: "periodStartDate",
              errorType: "invalidDate",
            })
          }
          slotProps={{
            textField: {
              error:
                !values.orderTemplate.periodStartDate &&
                !!periodStartDateIsRequired,
              required: !!periodStartDateIsRequired,
              size: "small",
              name: "date",
              sx: {
                backgroundColor: "rgba(249, 249, 250, 0.6)",
              },
            },
          }}
        />
      </Grid>
    </>
  );
};

export default SalaryLimit;
